/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
// Add custom code below this line

// expand Details accordion on PDP for mobile
 function handleResize() {
    if (window.innerWidth > 768) {
      const accordionTitle = document.querySelector('.template-product .product__accordion button.product__accordion__title');
      if (accordionTitle) {
        setTimeout(() => {
          accordionTitle.click();
          }, 100);
      }
    }
  }

  // window.addEventListener('load', handleResize);
  // window.addEventListener('resize', handleResize); 
  handleResize();


  
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

